import React from 'react';

import { useSelector } from 'react-redux';

import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';

import { userSelector } from '../../../reducers/current-user-selectors';

import { UiKebabMenu } from '../../../ui/ui-kebab-menu';

import { canDeleteAutomation } from '../../utils/automation-permission-utils';
import {
  isApplicantAutomation,
  isApplicantAutomationJobOverride,
} from '../../utils/is-applicant-automation';

export const AutomationsActionsMenu = ({
  automation,
  toggleEditDialog,
  toggleCopyDialog,
  toggleDeleteDialog,
  handleRevert,
}: {
  automation: ApplicantAutomation | StartDateTriggeredCommunication;
  toggleEditDialog: () => void;
  toggleCopyDialog: () => void;
  toggleDeleteDialog: () => void;
  handleRevert: () => void;
}) => {
  const user = useSelector((state: any) => userSelector(state));
  const shouldDisableDelete = !canDeleteAutomation(automation, user);

  const shouldShowRevert =
    isApplicantAutomation(automation) && isApplicantAutomationJobOverride(automation);

  const shouldDisableEdit = Boolean(
    isApplicantAutomation(automation) && automation.isUsingApplicationQuestions,
  );

  return (
    <UiKebabMenu
      menuId={`automation-kebab-menu-${
        isApplicantAutomation(automation)
          ? automation.applicantTriggeredCommunicationId
          : automation.startDateTriggeredCommunicationId
      }`}
    >
      <Tooltip
        title={shouldDisableEdit ? 'Messages personalized by Team Engine cannot be edited' : ''}
        placement="top"
      >
        <span>
          <MenuItem
            onClick={toggleEditDialog}
            disabled={shouldDisableEdit}
            data-cy={`edit-${
              isApplicantAutomation(automation) ? 'applicant' : 'employee'
            }-automation`}
          >
            Edit Automation
          </MenuItem>
        </span>
      </Tooltip>
      <MenuItem onClick={toggleCopyDialog}>Copy Automation</MenuItem>
      {shouldShowRevert ? (
        <MenuItem onClick={handleRevert}>Revert To Default</MenuItem>
      ) : (
        <Tooltip
          title={
            shouldDisableDelete
              ? 'This is an organization default message used across all jobs, contact your account admin to delete'
              : ''
          }
        >
          <span>
            <MenuItem onClick={toggleDeleteDialog} disabled={shouldDisableDelete}>
              Delete Automation
            </MenuItem>
          </span>
        </Tooltip>
      )}
    </UiKebabMenu>
  );
};
